import HttpService from './HttpService';
import { pollToLiveeFormat } from 'polle-shared-formatters';

class PollService extends HttpService {
  constructor() {
    super();
  }

  getPolls() {
    return this.http
      .get('/api/polls')
      .then(this.onResponse)
      .then(({ data }) => {
        return data.map(pollToLiveeFormat);
      })
      .catch(this.onError);
  }

  getPoll(id) {
    return this.http
      .get(`/api/poll/${id}`)
      .then(this.onResponse)
      .then(({ data }) => {
        return pollToLiveeFormat(data);
      })
      .catch(this.onError);
  }

  getVotesOfPoll(pollId) {
    return this.http
      .get(`/api/poll/${pollId}/votedquestions`)
      .then(this.onResponse)
      .then(({ data }) => {
        return data.VotedQuestions;
      })
      .catch(this.onError);
  }
}

export default new PollService();
